<template>
  <div class="col-md-12 pl-0 pr-0 yuanjiao" style="background: #fff">
    <skeleton-screen class="mt-3" v-if="!dataLoaded"></skeleton-screen>

    <!-- 新版样式 -->
    <!-- 摘要 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">📋</i>
        {{ $t("摘要") }}
      </div>
      <div class="mt-3" v-html="formattedDescription(info.description)"></div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 活动目标 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">🎯</i>
        {{ $t("活動目標") }}
      </div>
      <div
        class="mt-3"
        v-if="info.sdgs"
        :class="screenWidth <= 1200 ? '' : 'd-flex'"
      >
        <div
          class="mr-2 pl-3 pr-3 pt-2 pb-2 yuanjiao8"
          :class="screenWidth <= 1200 ? 'mb-2' : ''"
          style="background: #f6f4f0"
          v-for="(item, index) in info.sdgs"
          :key="index"
        >
          {{ item.description }}
        </div>
      </div>
      <div class="card-title mt-3">
        {{ $t("量化目標") }}
      </div>
      <div v-for="(item, index) in info.quantitative_goal" :key="index">
        <div class="mt-3 d-flex justify-content-between align-items-center">
          <div class="" style="font-size: 16px; font-weight: 500">
            {{ item.description }}
          </div>
          <div class="" style="font-size: 16px; font-weight: 500">
            {{ item.goals }}
          </div>
        </div>
        <b-progress
          :value="item.pro || 0"
          max="100"
          height="8px"
          class="mt-1 yuanjiao progress-div"
        ></b-progress>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 活动基本咨询 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">📋</i>
        {{ $t("活動基本資訊") }}
      </div>
      <div
        class="mt-3"
        :class="
          screenWidth <= 1200
            ? ''
            : 'd-flex justify-content-between align-items-center'
        "
        style="flex-wrap: wrap"
      >
        <div
          class="d-flex mb-3"
          :style="{ width: screenWidth <= 1200 ? '100%' : '50%' }"
        >
          <div
            class="mr-2 d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            📅
          </div>
          <div class="">
            <div style="font-weight: 600">{{ $t("活動時間") }}</div>
            <div class="mt-1" style="color: #666">
              {{ info.start_date }} - {{ info.end_date }}
            </div>
          </div>
        </div>
        <div
          class="d-flex mb-3"
          :style="{ width: screenWidth <= 1200 ? '100%' : '50%' }"
        >
          <div
            class="mr-2 d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            🤝
          </div>
          <div class="">
            <div style="font-weight: 600">{{ $t("協辦單位") }}</div>
            <div class="mt-1" style="color: #666">
              <span
                v-for="(item, index) in info.co_organizer"
                :key="index"
                class="mr-1"
                >{{ item.name }}</span
              >
            </div>
          </div>
        </div>
        <div
          class="d-flex mb-3"
          :style="{ width: screenWidth <= 1200 ? '100%' : '50%' }"
        >
          <div
            class="mr-2 d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            📍
          </div>
          <div class="">
            <div style="font-weight: 600">{{ $t("活动地点") }}</div>
            <div class="mt-1" style="color: #666">{{ info.address }}</div>
          </div>
        </div>
        <div
          class="d-flex mb-3"
          :style="{ width: screenWidth <= 1200 ? '100%' : '50%' }"
        >
          <div
            class="mr-2 d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            🏷️
          </div>
          <div class="">
            <div style="font-weight: 600">{{ $t("活動類型") }}</div>
            <div class="mt-1" style="color: #666">{{ info.category }}</div>
          </div>
        </div>
        <div
          class="d-flex mb-3"
          :style="{ width: screenWidth <= 1200 ? '100%' : '50%' }"
        >
          <div
            class="mr-2 d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            👥
          </div>
          <div class="">
            <div style="font-weight: 600">{{ $t("主辦單位") }}</div>
            <div class="mt-1" style="color: #666">{{ info.organizer }}</div>
          </div>
        </div>
        <div
          class="d-flex mb-3"
          :style="{ width: screenWidth <= 1200 ? '100%' : '50%' }"
        >
          <div
            class="mr-2 d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            🎯
          </div>
          <div class="">
            <div style="font-weight: 600">{{ $t("活動人數上限") }}</div>
            <div class="mt-1" style="color: #666">
              {{ info.maximum_user || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 活动地点 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">🗺️</i>
        {{ $t("活动地点") }}
      </div>
      <div class="mt-2">
        <div class="map-placeholder yuanjiao" v-if="!info.address">
          {{ $t("地圖載入中") }}
        </div>
        <div v-else>
          <moduleMap
            style="width: 100%; height: 300px"
            :searchValue="info.address || '台湾'"
            :zoom="15"
          ></moduleMap>
        </div>
      </div>
      <div class="mt-3">{{ $t("活动地点") }}： {{ info.address }}</div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 活动日程 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">📅</i>
        {{ $t("活動日程") }}
      </div>
      <div class="mt-4" v-for="(item, index) in schedule" :key="index">
        <div class="schedule-title">
          Day {{ index + 1 }} ({{ timeFilters3(item.date) }})
        </div>
        <div
          class="schedule-item d-flex align-items-center"
          v-for="(itemVal, indexVal) in item.list"
          :key="indexVal"
        >
          <div class="mr-3">
            {{ itemVal.start_time }} - {{ itemVal.end_time }}
          </div>
          <div class="">{{ itemVal.content }}</div>
        </div>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 主辦與協辦單位 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">🏢</i>
        {{ $t("主辦與協辦單位") }}
      </div>
      <div class="mt-3 d-flex" v-if="info.sdgs">
        <div
          class="mr-2 pl-4 pr-4 pt-3 pb-3 yuanjiao8"
          style="background: #f6f4f0"
          v-for="(item, index) in info.co_organizer"
          :key="index"
        >
          <!-- <img style="width: calc(15px + 0.4vw);height: calc(15px + 0.4vw);" src="@/img/icon_huodongbaogao@1x.png" alt="" class="mr-2"> -->
          {{ item.name }}
        </div>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 志工資訊 -->
    <div
      class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise"
      v-if="needVolunteer"
    >
      <div class="card-title">
        <i style="margin-right: 10px">👨‍🏫</i>
        {{ $t("志工資訊") }}
      </div>
      <div class="card-box pl-3 pr-3 pt-3 pb-3">
        <div
          class="d-flex justify-content-between align-items-center pb-4"
          style="border-bottom: 1px solid #eee"
        >
          <div class="d-flex align-items-center">
            <div
              class="d-flex align-items-center justify-content-center mr-2"
              style="
                width: 50px;
                height: 50px;
                border-radius: 10px;
                background-color: #ffd672;
                font-size: 24px;
              "
            >
              👨‍🏫
            </div>
            <div class="">
              <div style="font-size: 18px; font-weight: 600">
                {{ $t("成為") }}{{ info.name }}{{ $t("志工") }}
              </div>
              <div style="font-size: 14px; color: #666">
                {{ $t("志工時間") }}：{{ info.worker_schedule_time }}
              </div>
            </div>
          </div>
          <div class="yellow-btn" @click="chanyughd()">
            {{ $t("立即報名") }}
          </div>
        </div>
        <div
          class="mt-4 pl-3 pr-3 pt-3 pb-3 training-note"
          v-if="hasValidVolunteerInstructions"
        >
          <div class="">
            <i style="margin-right: 10px">📝</i>
            {{ $t("志工資訊") }}
          </div>
          <template v-for="(item, index) in info.volunteer_instructions">
            <div
              class="mt-2"
              style="color: #555"
              v-if="item.text && item.text.trim() !== ''"
              :key="index"
            >
              ● {{ item.text }}
            </div>
          </template>
        </div>
        <div class="card-title mt-3">
          {{ $t("志工培訓計劃") }}
        </div>
        <Timeline
          :timelineDesc="info.training_setting"
          :width="480"
          class="mt-4"
        />
        <div
          class="pl-3 pr-3 pt-3 pb-3 training-note"
          style="margin-top: 0"
          v-if="hasValidTrainingInstructions"
        >
          <div class="">
            <i style="margin-right: 10px">📝</i>
            {{ $t("培訓須知") }}
          </div>
          <template v-for="(item, index) in info.training_instructions">
            <div
              class="mt-2"
              style="color: #555"
              v-if="item.text && item.text.trim() !== ''"
              :key="index"
            >
              ● {{ item.text }}
            </div>
          </template>
        </div>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      v-if="needVolunteer"
    >
      <div class="boxHr"></div>
    </div>

    <!-- 活動QA -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">❓</i>
        {{ $t("活動QA") }}
      </div>
      <div class="mt-3" v-for="(item, index) in qa" :key="index">
        <div
          class="mt-3 d-flex justify-content-between align-items-center curpo"
          @click="showOrhidden(item)"
        >
          <div>{{ item.question }}</div>
          <div v-if="item.clickAble">-</div>
          <div v-else>+</div>
        </div>
        <div
          class="mt-3 pl-3"
          style="border-left: 3px solid #ffd672"
          v-if="item.clickAble"
        >
          {{ item.answer }}
        </div>
        <div class="mt-3" style="border-bottom: 1px solid #eee"></div>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <div class="boxHr"></div>
    </div>

    <!-- 聯絡資訊 -->
    <div class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise">
      <div class="card-title">
        <i style="margin-right: 10px">📞</i>
        {{ $t("聯絡資訊") }}
      </div>
      <div
        class="mt-3"
        :class="
          screenWidth <= 1200
            ? ''
            : 'd-flex justify-content-between align-items-center'
        "
      >
        <div
          class="contact-method"
          :class="screenWidth <= 1200 ? 'contact-method-all mb-2' : ''"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            📞
          </div>
          <div class="ml-3">
            <div>{{ $t("電話") }}</div>
            <div>{{ info.phone_of_organizer }}</div>
          </div>
        </div>
        <div
          class="contact-method"
          :class="screenWidth <= 1200 ? 'contact-method-all mb-2' : ''"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            ✉️
          </div>
          <div class="ml-3">
            <div>{{ $t("電子郵件") }}</div>
            <div>{{ info.email_of_organizer }}</div>
          </div>
        </div>
        <div
          class="contact-method curpo"
          :class="screenWidth <= 1200 ? 'contact-method-all mb-2' : ''"
          @click="goWeb(info.about_line)"
        >
          <div
            class="d-flex justify-content-center align-items-center"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #fffaf0;
            "
          >
            💬
          </div>
          <div class="ml-3" style="flex: 1; overflow: hidden">
            <div>{{ $t("LINE官方帳號") }}</div>
            <div class="ellipsis">{{ info.about_line || "--" }}</div>
          </div>
        </div>
      </div>
    </div>

    <div
      style="
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      "
      v-if="screenWidth <= 1200"
    >
      <div class="boxHr"></div>
    </div>

    <!-- 活動成員 -->
    <div
      class="col-md-12 yuanjiao pt-4 pb-4 pl-4 pr-4 mt-3 mb-3 baise"
      v-if="screenWidth <= 1200"
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <div class="card-title">
          <i style="margin-right: 10px">👨‍🚀</i>
          {{ $t("活動成員") }}
        </div>
        <button
          @click="showModal = true"
          class="pl-2 pr-2 pt-1 pb-1 yuanjiao curpo ckqbb yellowBtn"
          style="
            font-size: calc(10px + 0.4vw);
            background: #ffd672;
            border: none;
            color: #000;
            font-weight: 500;
          "
        >
          {{ $t("查看所有") }}
        </button>
      </div>
      <div
        class="mb-2 ml-3 mr-3"
        style="font-size: calc(14px + 0.5vw); font-weight: 600"
        v-if="volunteerList.length > 0"
      >
        <div>{{ $t("志工") }}</div>
      </div>
      <div
        class="mb-2 ml-3 mr-3"
        style="height: 1px; background: #e5e5e5"
        v-if="volunteerList.length > 0"
      ></div>
      <div
        @click="funs(item.user_id, item.user_slug)"
        v-for="(item, index) in volunteerList"
        :key="index"
        class="d-flex curpo justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2"
      >
        <div class="d-flex justify-content-between align-items-center">
          <img
            class="mr-2"
            style="
              width: calc(35px + 0.5vw);
              height: calc(35px + 0.5vw);
              border-radius: 50%;
            "
            :src="item.avatar"
            alt=""
          />
          <div>
            <div
              class="ellipsis"
              style="font-size: calc(12px + 0.4vw); width: auto"
            >
              {{ item.username }}
            </div>
            <div class="d-flex align-items-center mt-1">
              <div
                class="d-flex mr-2 align-items-center"
                style="font-size: calc(10px + 0.4vw); color: #666666"
              >
                <div>{{ item.nickname }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mb-2 ml-3 mr-3"
        style="font-size: calc(14px + 0.5vw); font-weight: 600"
        v-if="participateList.length > 0"
      >
        <div>{{ $t("一般參與者") }}</div>
      </div>
      <div
        class="mb-2 ml-3 mr-3"
        style="height: 1px; background: #e5e5e5"
        v-if="participateList.length > 0"
      ></div>
      <div
        @click="funs(item.user_id, item.user_slug)"
        v-for="(item, index) in participateList"
        :key="index"
        class="d-flex curpo justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2"
      >
        <div class="d-flex justify-content-between align-items-center">
          <img
            class="mr-2"
            style="
              width: calc(35px + 0.5vw);
              height: calc(35px + 0.5vw);
              border-radius: 50%;
            "
            :src="item.avatar"
            alt=""
          />
          <div>
            <div
              class="ellipsis"
              style="font-size: calc(12px + 0.4vw); width: auto"
            >
              {{ item.username }}
            </div>
            <div class="d-flex align-items-center mt-1">
              <div
                class="d-flex mr-2 align-items-center"
                style="font-size: calc(10px + 0.4vw); color: #666666"
              >
                <div>{{ item.nickname }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="所有活動參與者"
      v-model="showModal"
      style="text-align: center"
      modal-class="custom-modal-width"
      :centered="true"
      hide-footer
    >
      <div style="max-height: 70vh; overflow-y: auto">
        <div
          class="mb-2 ml-3 mr-3"
          style="font-size: calc(14px + 0.5vw); font-weight: 600"
          v-if="allList.volunteerList.length > 0"
        >
          <div>{{ $t("志工") }}</div>
        </div>
        <div
          class="mb-2 ml-3 mr-3"
          style="height: 1px; background: #e5e5e5"
          v-if="allList.volunteerList.length > 0"
        ></div>
        <div
          @click="funs(item.user_id, item.user_slug)"
          v-for="(item, index) in allList.volunteerList"
          :key="index"
          class="d-flex curpo justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2"
        >
          <div class="d-flex justify-content-between align-items-center">
            <img
              class="mr-2"
              style="
                width: calc(35px + 0.5vw);
                height: calc(35px + 0.5vw);
                border-radius: 50%;
              "
              :src="item.avatar"
              alt=""
            />
            <div>
              <div
                class="ellipsis"
                style="font-size: calc(12px + 0.4vw); width: auto"
              >
                {{ item.username }}
              </div>
              <div class="d-flex align-items-center mt-1">
                <div
                  class="d-flex mr-2 align-items-center"
                  style="font-size: calc(10px + 0.4vw); color: #666666"
                >
                  <div>{{ item.nickname }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="mb-2 ml-3 mr-3"
          style="font-size: calc(14px + 0.5vw); font-weight: 600"
          v-if="allList.participateList.length > 0"
        >
          <div>{{ $t("一般參與者") }}</div>
        </div>
        <div
          class="mb-2 ml-3 mr-3"
          style="height: 1px; background: #e5e5e5"
          v-if="allList.participateList.length > 0"
        ></div>
        <div
          @click="funs(item.user_id, item.user_slug)"
          v-for="(item, index) in allList.participateList"
          :key="index"
          class="d-flex curpo justify-content-between align-items-center mb-2 xunafuxgio pl-3 pr-3 pt-2 pb-2"
        >
          <div class="d-flex justify-content-between align-items-center">
            <img
              class="mr-2"
              style="
                width: calc(35px + 0.5vw);
                height: calc(35px + 0.5vw);
                border-radius: 50%;
              "
              :src="item.avatar"
              alt=""
            />
            <div>
              <div
                class="ellipsis"
                style="font-size: calc(12px + 0.4vw); width: auto"
              >
                {{ item.username }}
              </div>
              <div class="d-flex align-items-center mt-1">
                <div
                  class="d-flex mr-2 align-items-center"
                  style="font-size: calc(10px + 0.4vw); color: #666666"
                >
                  <div>{{ item.nickname }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- 旧版样式 -->
    <!-- <div v-if="dataLoaded" class="col-md-12 yuanjiao pt-3 pb-3 pl-0 pr-0 d-flex justify-content-between"> -->
    <div
      v-if="false"
      class="col-md-12 yuanjiao pt-3 pb-3 pl-0 pr-0 d-flex justify-content-between"
    >
      <div class="col-md-12 pl-0 pr-0">
        <div
          class="col-sm-12 baise yuanjiao pl-0 pr-0 pt-3 pb-3 mt-3 pl-3 pr-3"
        >
          <div class="d-flex" style="justify-content: flex-end">
            <div
              class="pl-3 pr-3 pt-2 pb-2 sjbxzt d-flex align-items-center"
              style="
                background: #e5e5e5;
                color: #999999;
                font-size: calc(8px + 0.4vw);
                border-radius: 8px;
              "
            >
              <div class="mr-1">
                <img
                  style="width: calc(15px + 0.4vw); height: calc(15px + 0.4vw)"
                  src="@/img/icon_huodongbaogao@1x.png"
                  alt=""
                />
              </div>
              <div>{{ $t("活動報告") }}</div>
            </div>
          </div>
          <!-- <div class="sjtoto" style="font-size: calc(7px + 0.5vw);font-weight: 600;">
            <div>{{ data.organization_name }}</div>
          </div>
          <div class="d-flex col-sm-12 pl-0 pr-0 mt-3 yinc">
            <div class="mr-2 pt-1 pb-1 pl-3 pr-3 yuanjiao sjbzt" style="font-size: calc(6px + 0.5vw);font-weight: 600;background-color: #FFEAB8;">09.09.2024
            - 09.10.2024</div>
            <div class="mr-2 pt-1 pb-1 pl-3 pr-3 yuanjiao sjbzt" style="font-size: calc(6px + 0.5vw);font-weight: 500;background-color: #FCD7D5;">
            {{ data.organization_name }}</div>
          </div>
          <div class="pl-0 pr-0 mt-3 aaaa">
            <div class="mr-2 pt-1 pb-1 pl-3 pr-3 yuanjiao sjbzt mb-2" style="font-size: calc(6px + 0.5vw);font-weight: 600;background-color: #FFEAB8;">09.09.2024
            - 09.10.2024</div>
            <div class="mr-2 pt-1 pb-1 pl-3 pr-3 yuanjiao sjbzt mb-2" style="font-size: calc(6px + 0.4vw);font-weight: 500;background-color: #FCD7D5;">
            {{ data.organization_name }}</div>
          </div> -->
          <div
            class="mb-2 sjbzt"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("摘要") }}
          </div>
          <div
            class="col-md-12 pl-0 pr-0 sjbxzt mb-3"
            v-html="formattedDescription(info.description)"
            style="font-size: calc(10px + 0.4vw)"
          ></div>
          <div
            class="mb-3 sjbzt"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("活動基本資訊") }}
          </div>
          <div class="d-flex align-items-stretch justify-content-between yinc">
            <div
              class="yuanjiao p-3"
              style="
                background: #f6f4f0;
                color: #666666;
                font-size: calc(10px + 0.4vw);
                width: 33%;
              "
            >
              <div class="mb-2">{{ $t("活动名称") }}</div>
              <div style="color: #1a1a1a">{{ info.name }}</div>
            </div>
            <div
              class="yuanjiao p-3"
              style="
                background: #f6f4f0;
                color: #666666;
                font-size: calc(10px + 0.4vw);
                width: 33%;
              "
            >
              <div class="mb-2">{{ $t("主辦單位") }}</div>
              <div style="color: #1a1a1a">{{ info.organizer }}</div>
            </div>
            <div
              class="yuanjiao p-3"
              style="
                background: #f6f4f0;
                color: #666666;
                font-size: calc(10px + 0.4vw);
                width: 33%;
              "
            >
              <div class="mb-2">{{ $t("協辦單位") }}</div>
              <div
                style="color: #1a1a1a"
                class="mb-1"
                v-for="(item, index) in info.co_organizer"
                :key="index"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-stretch justify-content-between mt-3 yinc"
          >
            <div
              class="yuanjiao p-3"
              style="
                background: #f6f4f0;
                color: #666666;
                font-size: calc(10px + 0.4vw);
                width: 33%;
              "
            >
              <div class="mb-2">{{ $t("活動種類") }}</div>
              <div style="color: #1a1a1a">{{ info.category }}</div>
            </div>
            <div
              class="yuanjiao p-3"
              style="
                background: #f6f4f0;
                color: #666666;
                font-size: calc(10px + 0.4vw);
                width: 33%;
              "
            >
              <div class="mb-2">{{ $t("活動時間") }}</div>
              <div style="color: #1a1a1a">
                {{ info.start_date }} - {{ info.end_date }}
              </div>
            </div>
            <div
              class="yuanjiao p-3"
              style="
                background: #f6f4f0;
                color: #666666;
                font-size: calc(10px + 0.4vw);
                width: 33%;
              "
            >
              <div class="mb-2">{{ $t("活動地點") }}</div>

              <div style="color: #1a1a1a">{{ info.address }}</div>
            </div>
          </div>

          <!--  <div v-for="(items,indexs) in item.label" :key="indexs" class="pl-2 pr-2 pt-1 pb-1" style="background: #FFEAB8;border-radius: 8px;">
                            {{ items }}
                          </div> -->
          <div class="aaaa">
            <div class="d-flex align-items-stretch justify-content-between">
              <div
                class="yuanjiao p-3"
                style="
                  background: #f6f4f0;
                  color: #666666;
                  font-size: calc(10px + 0.4vw);
                  width: 49%;
                "
              >
                <div class="mb-2">{{ $t("活動名稱") }}</div>
                <div style="color: #1a1a1a">{{ info.name }}</div>
              </div>
              <div
                class="yuanjiao p-3"
                style="
                  background: #f6f4f0;
                  color: #666666;
                  font-size: calc(10px + 0.4vw);
                  width: 49%;
                "
              >
                <div class="mb-2">{{ $t("主辦單位") }}</div>
                <div style="color: #1a1a1a">{{ info.organizer }}</div>
              </div>
            </div>
            <div
              class="d-flex align-items-stretch justify-content-between mt-3"
            >
              <div
                class="yuanjiao p-3"
                style="
                  background: #f6f4f0;
                  color: #666666;
                  font-size: calc(10px + 0.4vw);
                  width: 49%;
                "
              >
                <div class="mb-2">{{ $t("協辦單位") }}</div>
                <div
                  style="color: #1a1a1a"
                  class="mb-1"
                  v-for="(item, index) in info.co_organizer"
                  :key="index"
                >
                  {{ item.name }}
                </div>
              </div>
              <div
                class="yuanjiao p-3"
                style="
                  background: #f6f4f0;
                  color: #666666;
                  font-size: calc(10px + 0.4vw);
                  width: 49%;
                "
              >
                <div class="mb-2">{{ $t("活動種類") }}</div>
                <div style="color: #1a1a1a">{{ info.category }}</div>
              </div>
            </div>
            <div
              class="d-flex align-items-stretch justify-content-between mt-3"
            >
              <div
                class="yuanjiao p-3"
                style="
                  background: #f6f4f0;
                  color: #666666;
                  font-size: calc(10px + 0.4vw);
                  width: 49%;
                "
              >
                <div class="mb-2">{{ $t("活動地點") }}</div>
                <div style="color: #1a1a1a">{{ info.address }}</div>
              </div>
              <div
                class="yuanjiao p-3"
                style="
                  background: #f6f4f0;
                  color: #666666;
                  font-size: calc(10px + 0.4vw);
                  width: 49%;
                "
              >
                <div class="mb-2">{{ $t("活動時間") }}</div>
                <div style="color: #1a1a1a">
                  {{ info.start_date }} - {{ info.end_date }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="mb-3 sjbzt mt-3"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("活動聯絡人") }}
          </div>
          <div class="d-flex">
            <div
              class="mr-2 p-3"
              :key="index"
              style="
                width: 100%;
                font-size: calc(10px + 0.4vw);
                background: #fffaf0;
                border-left: 3px solid #ffd672;
              "
            >
              <div class="mb-2">
                {{ $t("姓名") }}
                <span style="margin-left: 20px">{{
                  info.name_of_organizer
                }}</span>
              </div>
              <div class="mb-2">
                {{ $t("電話") }}
                <span style="margin-left: 20px">{{
                  info.phone_of_organizer
                }}</span>
              </div>
              <div>
                {{ $t("信箱") }}
                <span style="margin-left: 20px">{{
                  info.email_of_organizer
                }}</span>
              </div>
            </div>
          </div>
          <div
            v-if="info.sdgs.length > 0"
            class="mb-3 sjbzt mt-3"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("活動目標") }}
          </div>
          <div
            v-if="info.sdgs.length > 0"
            class="d-flex"
            style="flex-wrap: wrap"
          >
            <div
              class="mr-2"
              v-for="(item, index) in info.sdgs"
              :key="index"
              style="width: calc(60px + 0.4vw); height: calc(60px + 0.4vw)"
            >
              <img
                style="width: 100%; height: 100%; object-fit: cover"
                :src="item.image"
                alt=""
              />
            </div>
          </div>
          <div
            class="mb-3 sjbzt mt-3"
            v-if="stakeholder.length > 0"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("重要利害關係人") }}
          </div>
          <div
            class="d-flex yinc"
            v-if="stakeholder.length > 0"
            style="flex-wrap: wrap; justify-content: space-between"
          >
            <div
              class="mr-2 p-3"
              v-for="(item, index) in stakeholder"
              :key="index"
              style="
                width: 24%;
                font-size: calc(10px + 0.4vw);
                background: #fffaf0;
                border-left: 3px solid #ffd672;
              "
            >
              {{ item.name + item.num + item.unit }}
            </div>
          </div>

          <div v-if="info.is_training == 2">
            <div
              class="mb-3 sjbzt mt-3"
              style="font-weight: 600; font-size: calc(12px + 0.4vw)"
            >
              {{ $t("志工培訓") }}
            </div>
            <div class="d-flex yinc">
              <div
                class="mr-2 p-3"
                :key="index"
                style="
                  width: 100%;
                  font-size: calc(10px + 0.4vw);
                  background: #fffaf0;
                  border-left: 3px solid #ffd672;
                "
                v-if="info.training_start_time"
              >
                {{ $t("培訓時間") }}
                <span style="margin-left: 20px"
                  >{{ info.training_start_time }} -
                  {{ info.training_end_time }}</span
                >
              </div>
            </div>
            <div
              class="d-flex yinc"
              style="margin-top: 10px"
              v-if="info.training_information"
            >
              <div
                class="mr-1 p-3"
                :key="index"
                style="
                  width: 100%;
                  font-size: calc(10px + 0.4vw);
                  background: #fffaf0;
                  border-left: 3px solid #ffd672;
                "
              >
                {{ $t("培訓資訊") }}
                <span style="margin-left: 20px">{{
                  info.training_information
                }}</span>
              </div>
            </div>
          </div>
          <div class="aaaa" v-if="stakeholder.length > 0">
            <div
              class="d-flex"
              style="flex-wrap: wrap; justify-content: space-between"
            >
              <div
                class="mr-2 p-3"
                v-for="(item, index) in stakeholder"
                :key="index"
                style="
                  width: 49%;
                  font-size: calc(10px + 0.4vw);
                  background: #fffaf0;
                  border-left: 3px solid #ffd672;
                "
              >
                {{ item.name + item.num + item.unit }}
              </div>
            </div>
          </div>
          <div
            v-if="qa.length > 0"
            class="mb-3 sjbzt mt-3"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("活動QA") }}
          </div>
          <div class="mb-3" v-for="(item, index) in qa" :key="index">
            <div
              class="d-flex mb-3 p-3 yuanjiao"
              style="align-items: center; background: #fffaf0"
            >
              <div class="mr-2">
                <img
                  style="width: calc(20px + 0.4vw)"
                  src="@/img/icon_a@1x.png"
                  alt=""
                />
              </div>
              <div style="font-size: calc(10px + 0.4vw)">
                {{ item.question }}
              </div>
            </div>
            <div
              class="d-flex mb-3 p-3 yuanjiao"
              style="align-items: center; background: #fffaf0"
            >
              <div class="mr-2">
                <img
                  style="width: calc(20px + 0.4vw)"
                  src="@/img/icon_q@1x.png"
                  alt=""
                />
              </div>
              <div style="font-size: calc(10px + 0.4vw)">{{ item.answer }}</div>
            </div>
          </div>
          <div
            v-if="schedule.length > 0"
            class="mb-3 sjbzt mt-3"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("活動行程") }}
          </div>
          <div class="col-sm-12 pl-0 pr-0 mt-4">
            <div
              v-for="(item, index) in schedule"
              :key="index"
              class="d-flex col-sm-12 pl-0 pr-0"
            >
              <div
                class="pl-0 pr-0 pl-3 pr-3 pt-1 text-center yuanjiao sjbdleftwj"
                style="
                  background-color: #ffd672;
                  height: calc(45px + 0.5vw);
                  width: calc(150px + 0.4vw);
                "
              >
                <div
                  class="sjbzt"
                  style="font-size: calc(8px + 0.4vw); font-weight: 700"
                >
                  {{ item.dates }}
                </div>
                <div class="sjbzt" style="font-size: calc(6px + 0.4vw)">
                  {{ item.date }}
                </div>
              </div>
              <div
                class="col-sm-10 col-md-11 pl-0 pr-0 d-flex align-items-center"
              >
                <div class="pl-3 col-sm-12 pl-0 pr-0">
                  <div
                    class="d-flex align-items-center"
                    v-for="(com, cindex) in item.list"
                    :key="cindex"
                  >
                    <div style="height: 100px; text-align: center">
                      <div
                        style="width: 1px; background: #ffeab8; height: 45%"
                      ></div>
                      <div
                        style="
                          width: 8px;
                          background: #ffeab8;
                          height: 8%;
                          border-radius: 50%;
                          margin-left: -3px;
                        "
                      ></div>
                      <div
                        style="width: 1px; background: #ffeab8; height: 50%"
                      ></div>
                    </div>
                    <div class="col-sm-12 pl-0 pr-0 pl-3">
                      <div
                        class="col-sm-12 pl-0 pr-0"
                        style="
                          background: #fffaf0;
                          height: 100px;
                          overflow: hidden;
                        "
                      >
                        <div class="p-3">
                          <div
                            class="mb-2 d-flex justify-content-between sjbxzt"
                            style="
                              font-size: calc(7px + 0.4vw);
                              font-weight: 700;
                            "
                          >
                            <div>{{ com.start_time }}-{{ com.end_time }}</div>
                            <div style="font-weight: 500">{{ com.date }}</div>
                          </div>
                          <div
                            style="
                              width: 100%;
                              height: 1px;
                              background: #1a1a1a;
                            "
                          ></div>
                          <div
                            class="mt-2 sjbxzt"
                            style="font-size: calc(7px + 0.4vw)"
                          >
                            <div>{{ com.content }}</div>
                          </div>
                        </div>
                        <div
                          style="width: 100%; height: 1rem; background: #ffffff"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="info.introduction"
            class="mb-2 sjbzt"
            style="font-weight: 600; font-size: calc(12px + 0.4vw)"
          >
            {{ $t("活動介紹") }}
          </div>
          <div
            v-if="info.introduction"
            class="col-md-12 pl-0 pr-0 sjbxzt mb-3"
            v-html="info.introduction"
            style="font-size: calc(10px + 0.4vw)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// formatTimestamps
import { formatTimestamps, formatTimestamp } from "@/utils/common.js";
import { activity_information, activity_member } from "@/request/hshd/index.js";
import SkeletonScreen from "./SkeletonScreen/xdSkeletonScreen.vue";
import Timeline from "@/components/Timeline/timeline.vue";
import Utils from "@/utils/util.js";
import moduleMap from "@/components/mapLocation/moduleMap";
export default {
  components: {
    SkeletonScreen,
    Timeline,
    moduleMap,
  },
  data() {
    return {
      // 获取当前屏幕的宽度设置css样式
      screenWidth: 0,
      txbiaod: 1,
      qa: [],
      stakeholder: {},
      info: {},
      schedule: [],
      name: "",
      dataLoaded: false,
      data: {},
      progress1: 33,
      progress2: 70,
      participateList: [],
      volunteerList: [],
      showModal: false,
      allList: {
        participateList: [],
        volunteerList: [],
      },
      timelineDesc: [
        "Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.",
        "Create a services site",
        "Create a services site",
        "Create a services site",
        "Create a services site",
      ],
    };
  },
  created() {
    this.name = this.$route.params.name;
    this.activity_schedule(this.$route.params.id);
    this.activity_member(this.$route.params.id);
    this.updateScreenWidth(); // 初始化宽度
    window.addEventListener("resize", this.updateScreenWidth);
  },
  mounted() {},
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  computed: {
    hasValidVolunteerInstructions() {
      return (
        this.info &&
        this.info.volunteer_instructions &&
        this.info.volunteer_instructions.length > 0 &&
        this.info.volunteer_instructions.some(
          (item) => item.text && item.text.trim() !== ""
        )
      );
    },
    hasValidTrainingInstructions() {
      return (
        this.info &&
        this.info.training_instructions &&
        this.info.training_instructions.length > 0 &&
        this.info.training_instructions.some(
          (item) => item.text && item.text.trim() !== ""
        )
      );
    },
    needVolunteer() {
      return this.info && this.info.need_volunteer == 1;
    },
  },
  methods: {
    async activity_member(id) {
      const { data, code } = await activity_member({
        id: id,
        page: "",
        account: "",
      });
      if (code == 200) {
        this.disposeList(data.data);
      }
    },

    disposeList(list) {
      if (list && list.length) {
        list.forEach((item, index) => {
          if (item.type == 1) {
            this.allList.participateList.push(item);
          } else if (item.type == 2) {
            this.allList.volunteerList.push(item);
          }
        });
        if (this.allList.participateList.length > 5) {
          this.participateList = this.allList.participateList.slice(0, 5);
        } else {
          this.participateList = this.allList.participateList;
        }
        if (this.allList.volunteerList.length > 5) {
          this.volunteerList = this.allList.volunteerList.slice(0, 5);
        } else {
          this.volunteerList = this.allList.volunteerList;
        }
      }
    },

    chanyughd() {
      let obj = {
        id: this.$route.params.id,
        name: this.info.name,
        info: this.info,
      };
      Utils.$emit("demo", obj);
    },

    custom() {
      this.txbiaod = 1;
    },

    hdfh(e) {
      this.txbiaod = 1;
      this.info.is_member = 1;
    },

    toOther() {
      this.$router.push("/activity/");
    },

    goWeb(url) {
      if (url) {
        window.open(url);
      } else {
        window.open("https://lin.ee/kp7oY4Tb");
      }
    },

    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },

    showOrhidden(item) {
      console.log(item, "触发");
      item.clickAble = !item.clickAble;
      this.$forceUpdate();
    },

    formattedDescription(e) {
      return e ? e.replace(/\n/g, "<br>") : "";
    },
    timeFilters(stringTime) {
      return formatTimestamps(stringTime * 1000);
    },
    timeFilters3(stringTime) {
      return formatTimestamp(stringTime * 1000);
    },
    async activity_schedule(e) {
      const { data, code } = await activity_information({
        id: e,
      });
      if (code == 200) {
        this.dataLoaded = true;
        this.qa = data.qa;
        for (let i = 0; i < this.qa.length; i++) {
          this.qa[i].clickAble = true;
        }

        this.stakeholder = data.stakeholder;
        this.info = data.info;

        // 確保 volunteer_instructions 和 training_instructions 是陣列
        if (typeof this.info.volunteer_instructions === "string") {
          try {
            this.info.volunteer_instructions = JSON.parse(
              this.info.volunteer_instructions
            );
          } catch (e) {
            this.info.volunteer_instructions = [];
          }
        }
        if (typeof this.info.training_instructions === "string") {
          try {
            this.info.training_instructions = JSON.parse(
              this.info.training_instructions
            );
          } catch (e) {
            this.info.training_instructions = [];
          }
        }

        this.schedule = data.schedule;
        console.log(data, "info");
      }
      this.data = data.data;
      // if (data.schedule) {
      //   this.schedule = data.schedule;
      //   for (let i = 0; i < this.schedule.length; i++) {
      //     const date = new Date(this.schedule[i].date * 1000); // 将时间戳转换为毫秒
      //     const year = date.getFullYear();
      //     const month = date.getMonth() + 1; // JavaScript中月份是从0开始的
      //     const day = date.getDate();
      //     this.schedule[i].date = year;
      //     this.$set(this.schedule[i], "dates", month + "-" + day);
      //     for (let j = 0; j < this.schedule[i].list.length; j++) {
      //       const dates = new Date(this.schedule[i].list[j].date * 1000); // 将时间戳转换为毫秒
      //       const years = dates.getFullYear();
      //       const months = dates.getMonth() + 1; // JavaScript中月份是从0开始的
      //       const days = dates.getDate();
      //       this.schedule[i].list[j].date = days + "-" + months + "-" + years;
      //     }
      //   }
      // }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 991px) {
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjtoto {
    font-size: calc(16px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .sjbdleftwj {
    width: calc(100px + 0.4vw) !important;
    height: calc(60px + 0.5vw) !important;
  }
  .yinc {
    display: none !important;
  }
  .aaaa {
    display: block !important;
  }
}
.boxHr {
  width: 95%;
  height: 1px;
  background: #d1d1d1;
}
.aaaa {
  display: none;
}
.dcbd:hover {
  transform: scale(1.2);
}

.inppt {
  background: white;
  border: none;
  border-radius: 13px;
  font-size: calc(7px + 0.4vw);
}

.xunafuxgio:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  /* 悬浮时添加阴影效果 */
}

.qieh {
  width: calc(100px + 0.4vw);
  text-align: center;
  border-radius: 12px 12px 0 0;
}

.sxbj {
  padding-top: calc(15px + 0.5vw);
  padding-bottom: calc(15px + 0.5vw);
}

.card-title {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
}

::v-deep .progress-bar {
  background: #ffd672;
}
.map-placeholder {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f6f4f0;
  color: white;
  font-size: 18px;
  font-weight: 600;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
.schedule-title {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ffd672;
}
.schedule-item {
  display: flex;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}
.card-box {
  margin: 20px 0;
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.yellow-btn {
  background-color: #ffd672;
  color: #333;
  border: none;
  padding: 8px 20px;
  border-radius: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 13px;
}
.yellow-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.training-note {
  margin-top: 30px;
  padding: 15px 20px;
  background-color: #fff9e6;
  border-radius: 12px;
  border-left: 4px solid #ffd672;
}
.contact-method {
  /* flex:1; */
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 12px;
  padding: 15px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  width: 32%;
}
.contact-method-all {
  width: 100%;
}
</style>
